app.controller('OrganizationalPositionsController', [
    '$scope', '$uibModal', 'Position', '$stateParams', 'OrganizationalUnit', 'usSpinnerService', 'ConfirmModal', 'toastr',
    function ($scope, $uibModal, Position, $stateParams, OrganizationalUnit, usSpinnerService, ConfirmModal, toastr) {
        $scope.unit = null;

        function fetchRootUnits() {
            return OrganizationalUnit.getById($stateParams.unit)
                .then(function (unit) {
                    $scope.unit = unit;
                });
        }

        fetchRootUnits();

        loadPage();

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Position.list({
                organization: $stateParams.unit
            }).then(function (data) {
                $scope.positions = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }


        $scope.add = function () {
            $uibModal.open({
                controller: 'OrganizationalPositionsAddController',
                templateUrl: _pb + 'employee/organizational-units/organizational-positions-add.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    params: {
                        id: $scope.unit._id
                    }
                }
            }).result
                .then(function () {
                    loadPage();
                }, function () {
                });
        };

        $scope.edit = function (position, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: 'OrganizationalPositionsAddController',
                templateUrl: _pb + 'employee/organizational-units/organizational-positions-add.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    params: {
                        id: position._id,
                        name: position.name,
                        description: position.description,
                        isRoot: position.isRoot,
                        organization: position.organization
                    }
                }
            }).result
                .then(function () {
                    loadPage();
                }, function () {
                });
        };

        $scope.remove = function (position, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ყურადღება",
                message: "გსურთ '" + position.name + "' წაშალოთ თანამდებობის სიიდან?"
            }).result.then(function () {
                Position.remove({
                    positionId: position._id
                }).then(function (resp) {
                    toastr.success('თანამდებობა წაშლილია');
                    loadPage();
                });
            });
        };
    }]);
